import { render, staticRenderFns } from "./HelpCenterAccountAppeal.vue?vue&type=template&id=6b78b8a7&scoped=true"
import script from "./HelpCenterAccountAppeal.vue?vue&type=script&lang=js"
export * from "./HelpCenterAccountAppeal.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterAccountAppeal.vue?vue&type=style&index=0&id=6b78b8a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78b8a7",
  null
  
)

export default component.exports